import { isEmpty, has } from 'lodash';
import { useSelector, shallowEqual } from 'react-redux';
import usageStatusSelectors from 'store/usage-status/selectors';
import { USAGE_STATUS_FIELDS } from 'domain/usage-status/consts';
import { reflectionTimeSelectors } from 'store/reflectiontime';
import { useMemo } from 'react';
import { CROSS_DEVICE } from 'services/common/reflectiontime/constants';
import { getCrossDevicePaidContract, getCrossDeviceFreeContract, getCrossDeviceMode } from 'store/auth/selectors';

const { OPTIONS } = USAGE_STATUS_FIELDS;
const CROSS_PAID = 2;
const NO_CROSS_PAID = 0;

const useCheckCrossDevicePaidContract = () => {
  const { usageStatusData } = useSelector(
    usageStatusSelectors.getStatesForUsageStatus,
    shallowEqual
  );

  const reflectionData = useSelector(
    reflectionTimeSelectors.getReflectionTimeData,
    shallowEqual
  );

  const isCrossDevicePaidContract = useSelector(
    getCrossDevicePaidContract,
    shallowEqual
  );

  const isCrossDeviceFreeContract = useSelector(  
    getCrossDeviceFreeContract,
    shallowEqual
  );

  const crossDeviceMode = useSelector(
    getCrossDeviceMode,
    shallowEqual
  );

  const crossDeviceData = useMemo(() => {
    if (isEmpty(reflectionData) || isEmpty(reflectionData[CROSS_DEVICE])) {
      return {};
    }
    return reflectionData[CROSS_DEVICE][0] || {};
  }, [reflectionData]);

  const isCrossDevicePaid = useMemo(() => {
    return crossDeviceData.paid_contract === CROSS_PAID;
  }, [crossDeviceData]);

  const { [OPTIONS]: options = {} } = usageStatusData;
  const paidContract = has(options, 'CROSS_PAID-1')
    ? CROSS_PAID
    : NO_CROSS_PAID;

  const crossDeviceContract = useMemo(() => {
    if (isCrossDevicePaidContract) {
      return 'paid';
    }
    if (isCrossDeviceFreeContract) {
      return 'free';
    }
    return '';
  }, [isCrossDevicePaidContract, isCrossDeviceFreeContract]);

  return {
    isCrossDevicePaidContract,
    isCrossDeviceFreeContract,
    isCrossDevicePaid,
    paidContract,
    crossDeviceContract,
    crossDeviceMode,
  };
};

export default useCheckCrossDevicePaidContract;